import React from 'react'

function Revenue() {
  return (
    <div>
      {/* revenue related cal and code can be written here */}
      <h2>I am from revenue</h2>
    </div>
  )
}

export default Revenue
